import { useStoreActions, useStoreState } from '~/store/hooks';
import { useApiRequest } from '~/hooks/api';

import AllocationTypes from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/constants/allocationTypes';
import {
  IUseGetDuplicateAllocationResult,
  IUseGetEditClientAllocationsParams,
} from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/EditClientAllocation/hooks/types';

const useGetDuplicateClientAllocationsForActTeamMember = ({
  actTeamId,
  clientAllocationDate,
  enabled = true,
}: IUseGetEditClientAllocationsParams): IUseGetDuplicateAllocationResult => {
  const { clinic: userClinic, id: userId } = useStoreState(state => state.user.current);
  const clientAllocations = useStoreState(state => state.clientAllocation.current) || [];

  const { onGetOwnClientAllocation } = useStoreActions(actions => actions.clientAllocation);

  const { isLoading, refetch } = useApiRequest(
    async () => {
      const allocationDate = `${clientAllocationDate}T00:00:00Z`;

      await onGetOwnClientAllocation({
        clientAllocationDate: allocationDate,
        allocationType: AllocationTypes.ALL,
      });
    },
    {
      enabled,
      dependencies: [actTeamId, clientAllocationDate, userClinic.id, userId],
    },
  );

  return {
    isLoading,
    allocations: clientAllocations,
    refetch,
  };
};

export default useGetDuplicateClientAllocationsForActTeamMember;
